import { BllServisBilgisi } from './../../providers/bll-servis-bilgisi';
import { BllSubeler } from './../../providers/bll/bll-subeler';
import { App_User } from './../../models/App_User';
import { ModalController } from 'ionic-angular/components/modal/modal-controller';
import { BllRememberAcc } from './../../providers/bll/bll-remember-acc';
import { Ortak } from './../../providers/ortak';
import { HomePage } from './../home/home';
import { BllOrtak } from './../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import { NavController, AlertController, App, MenuController } from 'ionic-angular';
import { ServerConfigPage } from '../Yonetim/server-config/server-config';
import { NL_Servis } from '../../models/NL_Servis';


@Component({
  selector: 'page-giris',
  templateUrl: 'giris.html',


})
export class GirisPage {
  sunucuAdresi = "";
  secilenadres: any = { ID: "", SubeAdi: "", SubeAdres: "" };
  txtkullaniciadi = "";
  txtsifre = "";
  bllRememberAcc: BllRememberAcc = new BllRememberAcc();
  girisBilgileriHatirla = 0;
  suankitarih;
  kullanicilar: any = { ID: "", Name: "", Sifre: "", OffMode: "", Type: "" };
  offmode: any;
  aktifKullaniciYetkiID: number = 0;
  act: any = { ID: 0 };
  subelistesi = [];
  subegirisiaktif: number = 0;
  constructor(
    public navCtrl: NavController,
    public menu: MenuController,
    public ortak: Ortak,
    public modalCtrl: ModalController,
    public bllOrtak: BllOrtak,
    public alert: AlertController,
    public app: App,
  ) {

  }

  ionViewDidLoad() {

    this.menu.enable(false);

    this.kullaniciGetir();
    this.gunkontrol();
    this.subelerigetir();
  }
  giris(e) {
    if (e.keyCode == 13) {
      this.girisislemi();
    }
  }
  subelerigetir() {
    var subeler = new BllSubeler();
    subeler.getAll().then(a => {
      var sonuc = <any>a;
      this.subelistesi = sonuc;
      if (this.subelistesi.length > 1) {
        this.subegirisiaktif = 1;

      }
    }).catch(x => {

    })
  }

  kullaniciGetir() {

    var bllRememberAcc = new BllRememberAcc();
    bllRememberAcc.getAll().then(b => {
      var sonuc = <any>b;
      this.kullanicilar = b[0];
      if (this.kullanicilar.length > 1)
        this.girisBilgileriHatirla = 1;
      this.txtkullaniciadi = sonuc[0].Sifre;
      this.txtsifre = sonuc[0].Name;

      this.girisBilgileriHatirla = 1;
    }).catch(x => { });


  }
  girisBilgileriniHatirlaIslemleri() {
    this.bllRememberAcc.deleteAll2().then(a => {
      if (this.girisBilgileriHatirla == 1) {
        var remAcc = new App_User();
        remAcc.Sifre = this.txtkullaniciadi;
        remAcc.Name = this.txtsifre;
        remAcc.Type = this.kullanicilar.Type;
        remAcc.OffMode = this.kullanicilar.OffMode;
        this.bllRememberAcc.addOrUpdate(remAcc).then(b => {
        })
      }
    })

  }

  // demogir() {
  //   this.txtsifre = "demo";
  //   this.txtkullaniciadi = "demo";
  //   this.onlinegiris();
  // }
  showRadio() {
    var radioAlertListesi = [];
    for (let i = 0; i < this.subelistesi.length; i++) {
      var checked = false;
      if (i == 0) {
        checked = true
      }

      radioAlertListesi.push({ value: this.subelistesi[i], label: this.subelistesi[i].SubeAdi, checked: checked, type: "radio" });
    }
    return new Promise((res, err) => {
      let alerts = this.alert.create({
        title: 'Şubeler',
        subTitle: 'Şube Seçiniz',
        inputs: radioAlertListesi,
        buttons: [
          {
            text: 'İptal',
            role: 'cancel',
            handler: data => {

            }
          },
          {
            text: 'Seç',
            handler: data => {
              res(data);
              this.secilenadres = data;

              this.adresdegistir();

            }
          }
        ]
      });
      alerts.present();
    })
  }

  girisislemi() {

    if (this.txtsifre == "****" && this.txtkullaniciadi == "***") {
      this.SunucuAyarlari();
    }
    else
     {
      // if (this.subegirisiaktif == 1) {
      //   this.showRadio();

      // }
      // else {
        this.onlinegiris();
      //}

    }
  }
  adresdegistir() {
    var bllServisBilgisi = new BllServisBilgisi();

    bllServisBilgisi.delete({ ID: 1 }).then(a => {

    });

    // bllServisBilgisi.getAll().then(b => {
    //   var sonuc = <any>b;
    //   if (sonuc.length > 0) {
    //     var guncellenecekElement = new NL_Servis();
    //     guncellenecekElement.ADRES = this.secilenadres.SubeAdres;
    //     guncellenecekElement.ID = 1;
    //     bllServisBilgisi.servisBilgisiGuncelle(guncellenecekElement);
    //     this.onlinegiris();
    //   }
    // });
    var servisadd = new NL_Servis();
    servisadd.ADRES = this.secilenadres.SubeAdres;
    servisadd.Tanim = this.secilenadres.SubeAdi;

    bllServisBilgisi.add(servisadd).then(a => {
      this.ortak.storageServisBilgisiEkle(servisadd);
      this.onlinegiris();
    });
  }

  onlinegiris() {
    // var formData = new FormData();
    // formData.append("aranan", this.txtsifre);
    // formData.append("kullaniciAdi", this.txtkullaniciadi);
    // this.bllOrtak.islem(formData, "Login", "", true).then(a => {
    //   var sonuc = <any>a;
    //   if (sonuc.Sonuc != 1) {
    //     this.ortak.showBasicAlert("Hata", "Kullanıcı Bulunmadı");
    //   }
    //   this.ortak.storagePersonelEkle(sonuc.SonucObject);
    //   this.aktifKullaniciYetkiID = this.ortak.storagePersonelGetir.Type;
    //   this.act.ID = 0;
    //   this.ortak.staccountadd(this.act);
    //   if (sonuc.Sonuc == 1) {
    //     this.kullanicilar = sonuc.SonucObject;
    //     this.girisBilgileriniHatirlaIslemleri();
    //     this.navCtrl.setRoot(HomePage, { user: this.kullanicilar });
    //     this.menu.enable(false);
    //   }
    //   if (sonuc.Sonuc != 1) {
    //     this.showAlert("Hata", "Kullanıcı Bulunamadı");
    //   }
    // }).catch(x => {
    // })
    var formData = new FormData();
    formData.append("aranan", this.txtsifre);
    formData.append("kullaniciAdi", this.txtkullaniciadi);
    this.bllOrtak.islem(formData, "Login", "", true).then(a => {
      var sonuc = <any>a;
      this.ortak.storagePersonelEkle(sonuc.SonucObject);
      if (sonuc.Sonuc == 1) {
        this.girisBilgileriniHatirlaIslemleri();
        this.navCtrl.setRoot(HomePage);
        this.menu.enable(false);
      }
      if (sonuc.Sonuc != 1) {
        this.showAlert("Hata", "Kullanıcı Bulunamadı");
      }
    })

  }

  showAlert(tittle: string, subTitle: string) {
    let alert = this.alert.create({
      title: tittle,
      subTitle: subTitle,
      buttons: ['Tamam']
    });
    alert.present();
  }
  gunkontrol() {
    this.bllOrtak.islemWithoutPost("GununTarihi", "", false).then(a => {
      var sonuc = <any>a;
      this.suankitarih = this.ortak.tarih(sonuc.SonucObject, "ll");
      this.ortak.storageGunTarihiEkle(sonuc.SonucObject);
    }).catch(x => {
    })
  }
  SunucuAyarlari() {
    let modal = this.modalCtrl.create(ServerConfigPage);
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });
    modal.present();

  }

}



// WEBPACK FOOTER //
// ./src/pages/giris/giris.ts